// extracted by mini-css-extract-plugin
export default {"day":"birthDateCalendar_day__CocLI"};